import { createApp } from 'vue';
import { createPinia } from 'pinia';

import { setupI18n } from '@/lib/i18n';

import { initializeFirebase } from '@/firebase';

import App from './App.vue';
import router from './router';

import './index.css';

import Vue3Toastify, { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

// Create a function to start the app
async function startApp() {
    try {
        // Wait for Firebase to initialize first
        await initializeFirebase();

        // Now we can safely create and mount the app
        const app = createApp(App);
        app.use(createPinia());

        const i18n = setupI18n();
        app.use(i18n);

        app.use(Vue3Toastify, {
            autoClose: 3000,
            position: 'bottom-right',
        });

        app.use(router);

        app.config.errorHandler = (error, _vm, _info) => {
            // Handle the error globally
            if (process.env.NODE_ENV === 'development') {
                toast.error(
                    'An unexpected error occurred, please check the console for more information.',
                );
            }
            console.error(error);
        };

        // Mount the app only after Firebase is ready
        app.mount('#app');
    } catch (error) {
        if (error instanceof Error) {
            console.error('Failed to initialize Firebase:', error.message);
            document.body.innerHTML = `
          <div>
            <h1>Application Error</h1>
            <p>${error.message}</p>
          </div>
        `;
        } else {
            console.error('Failed to initialize Firebase:', error);
            document.body.innerHTML = `
          <div>
            <h1>Application Error</h1>
            <p>Unknown error</p>
          </div>
        `;
        }
    }
}

// Start the application
startApp();
